import React, { useEffect } from "react";
import { useUsers } from "../../../application/users/hooks/useUsers";
import "./style.css"
import DynamicTable from "../../ui/table2";
import FloatingButton from '../../ui/floatButton';
import { ModalConfirm } from '../../ui/modal2';
import ToolbarComponent from "../../ui/section";

const UserView = (props) => {
    const {
        columns,
        users,
        customElements,
        removeModal,
        setRemoveModal,
        goNew,
        handleRemove,
        getAll,
    } = useUsers(props);

    useEffect(() => {
        getAll();
    }, [getAll]);

    return <>
        <ToolbarComponent label="Usuarios de sistema" showBackButton={false}>
            <DynamicTable
                headers={columns}
                data={users}
                customElements={customElements}
                tableLabel="Mis canjes"
                fullPage={true}
                showLabel={false}
            />
            <FloatingButton position="bottom-right" onClick={goNew}></FloatingButton>
            <ModalConfirm isOpen={removeModal} onClose={() => setRemoveModal(false)} onAccept={handleRemove} />
        </ToolbarComponent>
    </>
}

export default UserView;